import React, { useRef, useState } from 'react';
import DataServiceSQL from "../DataService/DataServiceSQL";
import { Col, Row } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../Pages/Constants';
import cookie from 'react-cookies';
import {FormattedMessage} from 'react-intl';
import DatePicker from 'react-date-picker';
import PatientFunctionsGetter from "../Controller/getSQLPatientFunctions.js";

import Utils from '../Components/Common/Utils.js';

const Research = (props) => {
    const { classes } = props;

    const [research, setResearch] = useState({birthdate: '', birthname: '', firstname: '', full_ins_code: '', ins_code: '', nir_key: ''});
    const [patientList, setPatientList] = useState([]);
    const [message, setMessage] = useState([]);
    const [messageError, setMessageError] = useState(false);

    //Function to check INS and NIR validity
    const checkCodesValidity = () => {
        let ret = true
        if ((research.ins_code.length !== 13 || research.nir_key.length !== 2) || (research.ins_code.match(/^[a-bA-B0-9]+$/) === null || research.nir_key.match(/^[0-9]+$/) === null)) {
            if (research.ins_code.length !== 13 || research.nir_key.length !== 2) {
                setMessage(<FormattedMessage id="research.error.INS.size" defaultMessage="Error: wrong INS number size" />);
            }
            else {
                setMessage(<FormattedMessage id="research.error.INS.nomatch" defaultMessage="Error: wrong INS number characters" />);
            }
            setMessageError(true);
            ret = false;
        }
        else if (parseInt(research.nir_key) > 97 || parseInt(research.nir_key) < 1) {
            setMessage(<FormattedMessage id="research.error.NIR" defaultMessage="Error: wrong NIR key" />);
            setMessageError(true);
            ret = false;
        }
        if (ret) {
        let i = 0
        while (research.ins_code[i]) {
            if (i === 6 && research.ins_code[i-1] === "2" && (research.ins_code[i] === "A" || research.ins_code[i] === "a" || research.ins_code[i] ==="B" || research.ins_code[i] === "b")) {
                null;
            }
            else if (research.ins_code[i] < "0" || research.ins_code[i] > "9") {
                setMessage(<FormattedMessage id="research.error.INS.num" defaultMessage="Error: wrong INS number" />);
                setMessageError(true);
                        ret = false;
            }
            i++;
        }
        let true_ins_code = "";
        i = 0
        while (research.ins_code[i]) {
            //Exceptions to deal with corsica departments
            if (i === 5 && research.ins_code[5] === "2" && (research.ins_code[6] === "A" || research.ins_code[6] === "a")) {
                true_ins_code = true_ins_code.concat("19")
                i++
            }
            else if (i === 5 && research.ins_code[5] === "2" && (research.ins_code[6] === "B" || research.ins_code[6] === "b")) {
                true_ins_code = true_ins_code.concat("18")
                i++
            }
            else {
                true_ins_code = true_ins_code.concat(research.ins_code[i])
            }
            i++;
        }
        //Testing correspondance between INS and NIR
        if (parseInt(research.nir_key) !== (97-(true_ins_code % 97))) {
            setMessage(<FormattedMessage id="research.error.corresponding" defaultMessage="Error: INS and NIR not corresponding" />);
            setMessageError(true);
                    ret = false;
            }
        }
        if (ret === false) {
        setMessageError(false);
            setPatientList([])
        }
        return (ret);
    }

    //Function to handle birthdate value
    const handleChangeBirthdate = (birthdate) => {

        setResearch({ ...research, birthdate: new Date(birthdate) });
    };

    //Function to handle birthname value
    const handleChangeBirthname = (birthname) => {
        setResearch({ ...research, birthname: birthname.target.value });
    };

    //Function to handle firstname value
    const handleChangeFirstname = (firstname) => {
        setResearch({ ...research, firstname: firstname.target.value });
    };

    //Function to handle full_ins_code value
    const handleChangeFullINSCode = (full_ins_code) => {
        let ins = full_ins_code.target.value.slice(0, 13)
        let nir = full_ins_code.target.value.slice(13)
        setResearch({ ...research, full_ins_code: full_ins_code.target.value, ins_code: ins, nir_key: nir });
    };

    //Function to handle ins_code value
    const handleChangeINSCode = (ins_code) => {
        setResearch({ ...research, ins_code: ins_code.target.value });
    };

    //Function to handle nir_key value
    const handleChangeNIRCode = (nir_key) => {
        setResearch({ ...research, nir_key: nir_key.target.value });
    };

    //Function to return patient sn
    const saveIdPatient = async (patient_sn) => {
        await props.handleFilterChange({target:{value:'{"id":"'+ patient_sn +'", "type":"patient"}'}}) 
        props.cancelPopup()
    };

    //Function to search patient
    const researchPatientsINS = async () => {
        let test = true;

        if (research.birthdate === "") {
            test = checkCodesValidity();
        }
        research.id_user = props.accountInformation.id_user;
        if (test === true) {
            PatientFunctionsGetter.search_Patients(research)
        .then(response => {
            let result = [];
            response.data.forEach(profile_data => {
                    let converted_data = JSON.parse(profile_data.data)
                    if (converted_data.INS_Data === undefined) {
                        converted_data.INS_Data = {
                            "Cle": converted_data.Cle,
                            "DateNaissance": converted_data.DateNaissance,
                            "LieuNaissance": converted_data.LieuNaissance,
                            "NomNaissance": converted_data.NomNaissance,
                            "NomUtilise": converted_data.NomUtilise,
                            "NumIdentifiant": converted_data.NumIdentifiant,
                            "OID": converted_data.OID,
                            "PremierPrenom": converted_data.PremierPrenom,
                            "PrenomNaissance": converted_data.PrenomNaissance,
                            "PrenomUtilise": converted_data.PrenomUtilise,
                            "Sex": converted_data.Sex
                        }
                    }
                    result.push(converted_data);
            })
            setPatientList(result)
        })
        .catch(e => {
            console.log("error while searching patients")
        });
    }
    }

    const listingPatients = () => {
        let ret = ""
        if (patientList.length !== 0) {
            return (
                <Row style={{width: "100%", fontSize:"100%"}}>
                Patient(s) found: {patientList.length}<br/><br/>
                {patientList.map(profile_data => {
                    profile_data = Utils.ins_format_data(profile_data);
                    return (
                        <span style={{border: "1px solid black"}} onClick={() => saveIdPatient(profile_data.id)}>
                            <div style={{width:"100%"}}>
                                <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                   <FormattedMessage id="INS.title" defaultMessage="INS data"/>
                                  </Row>
                                <br></br>
                                {(profile_data.INS_Data.NomUtilise !== undefined && profile_data.INS_Data.NomUtilise !== "") ?
                                    <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                        <FormattedMessage id="INS.lastnameused" defaultMessage="Lastname used : "/>
                                        {profile_data.INS_Data.NomUtilise}
                                    </Row>
                                    :
                                    <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                        <FormattedMessage id="INS.lastnameused" defaultMessage="Lastname used : "/>
                                        {profile_data.INS_Data.NomNaissance}
                                    </Row>
                                }
                                <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                    <FormattedMessage id="INS.firstfirstname" defaultMessage="First firstname : "/>
                                    {profile_data.INS_Data.PremierPrenom}
                                </Row>
                                {(profile_data.INS_Data.PrenomUtilise !== undefined && profile_data.INS_Data.PrenomUtilise !== "") ?
                                    <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                        <FormattedMessage id="INS.firstnameused" defaultMessage="Firstname used : "/>
                                        {profile_data.INS_Data.PrenomUtilise}
                                    </Row>
                                    :
                                    <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                        <FormattedMessage id="INS.firstnameused" defaultMessage="Firstname used : "/>
                                        {profile_data.INS_Data.PrenomNaissance}
                                    </Row>
                                }
                                <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                    <FormattedMessage id="INS.lastname" defaultMessage="Lastname : "/>
                                    {profile_data.INS_Data.NomNaissance}
                                </Row>
                                <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                    <FormattedMessage id="INS.firstname" defaultMessage="Firstname : "/>
                                    {profile_data.INS_Data.PrenomNaissance}
                                </Row>
                                {(profile_data.DateNaissance !== undefined && profile_data.DateNaissance !== "") ?
                                    <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                        <FormattedMessage id="INS.birthdate" defaultMessage="Birthdate : "/>
                                        {Utils.convert_date_to_full_date_string(profile_data.INS_Data.DateNaissance)}
                                    </Row>
                                    :
                                    null
                                }
                                {(profile_data.INS_Data.Sex !== undefined && profile_data.INS_Data.Sex !== "") ?
                                    <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                        <FormattedMessage id="INS.sex" defaultMessage="Sex : "/>
                                        {Utils.ins_convert_sex(profile_data.INS_Data.Sex)}
                                    </Row>
                                    :
                                    null
                                }
                                <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                    {(profile_data.INS_Data.NumIdentifiant === undefined || profile_data.INS_Data.NumIdentifiant === "") ?
                                        null
                                        :
                                        <p>
                                        <FormattedMessage id="INS.INSNumber" defaultMessage="INS : "/>
                                        {profile_data.INS_Data.NumIdentifiant}
                                        {(profile_data.OID === "1.2.250.1.213.1.4.8") ?
                                            <FormattedMessage id="INS.NIR" defaultMessage=" (NIR)"/>
                                            :
                                            <FormattedMessage id="INS.NIA" defaultMessage=" (NIA)"/>
                                        }
                                        </p>
                                    }
                                </Row>
                                <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                    <FormattedMessage id="INS.OID" defaultMessage="OID : "/>
                                    {profile_data.INS_Data.OID}
                                </Row>
                                <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                                    <FormattedMessage id="INS.birthplace" defaultMessage="Birthplace : "/>
                                    {profile_data.INS_Data.LieuNaissance}
                                </Row>
                            </div>
                        </span>
                    )
                })}
                </Row>
            )
        }
        else {
            return (
                <Row style={{width: "90%", fontSize:"120%"}}>
                    <h4>{message}</h4>
                </Row>
            )

        }
        if (messageError) {
            return (
                <Row style={{width: "100%", fontSize:"120%"}}>
                    <span>{message}</span>
                </Row>
            )
        }

        return(ret);
    }

    const cancelPopup = () => {

        let filter_select = document.getElementById("group_selector")
        filter_select.value = props.previous_filter
        props.cancelPopup();
    }

  	return (
        <div className={classes.popup_background}>
            <div style={{ height: "105%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                <div className="submit-form" style={{height: "80%"}}>
                    <Row className="justify-content-md-end" style = {{ paddingBottom: "10px" }}>
                        <Col style={{ fontWeight: "bold", fontSize:"2.2em" }}>
                            <center>
                                <FormattedMessage id="research.title" defaultMessage="Research" />
                            </center>
                        </Col>
                    </Row>
                    <Row style={{width: "100%", fontSize:"120%"}}>
                        <Col>
                            <label htmlFor="research birthname">
                            <FormattedMessage id="research.birthname" defaultMessage="Birthname" />
                            </label>

                            <input
                            type="text"
                            id="patient_birthname"
                            required
                            defaultValue=""
                            onChange={handleChangeBirthname}
                            name="patient_birthname"
                            style={{width: "100%", border: "1px solid gray"}}
                            />
                        </Col>
                    </Row>
                    <Row style={{width: "100%", fontSize:"120%"}}>
                        <Col>
                            <label htmlFor="research firstname">
                            <FormattedMessage id="research.firstname" defaultMessage="Firstname" />
                            </label>

                            <input
                            type="text"
                            id="patient_firstname"
                            required
                            defaultValue=""
                            onChange={handleChangeFirstname}
                            name="patient_firstname"
                            style={{width: "100%", border: "1px solid gray"}}
                            />
                        </Col>
                    </Row>
                    <Row style={{width: "100%", fontSize:"120%"}}>
                        <Col>
                            <label htmlFor="research birthdate">
                            <FormattedMessage id="research.birthdate" defaultMessage="Birthdate*" />
                            </label>

                            <DatePicker
                            calendarIcon={null}
                            clearIcon={null}
                            onChange={handleChangeBirthdate}
                            value={research.birthdate}
                            id="research_birthdate"
                            />
                        </Col>
                    </Row>
                    <br/><center>- <FormattedMessage id="research.or" defaultMessage="OR" /> -</center><br/>
                    <Row style={{width: "100%", fontSize:"120%"}}>
                        <Col>
                            <label htmlFor="research INS code">
                            <FormattedMessage id="research.INS.code" defaultMessage="Use INS registration number*" />
                            </label>

                            <input
                            type="text"
                            id="research_ins_code"
                            required
                            defaultValue=""
                            onChange={handleChangeFullINSCode}
                            onPaste={handleChangeFullINSCode}
                            name="research_ins_code"
                            style={{width: "100%", border: "1px solid gray"}}
                            />
                        </Col>
                    </Row>
                    <br/>
                    <Row style={{margin:"auto", width: "100%", fontSize:"120%"}}>
                        {listingPatients()}
                    </Row>
                    <br/>
                    <center>
                        <button onClick={researchPatientsINS} className="btn btn-success" disabled={!((research.birthdate !== "" || research.firstname !== "" || research.birthname !== "") ^ (research.full_ins_code !== ""))}>
                            <FormattedMessage id="button.search" defaultMessage="Research" />
                        </button>
                        <button onClick={cancelPopup} className="btn btn-danger">
                            <FormattedMessage id="button.close" defaultMessage="Close" />
                        </button>
                    </center>
                </div>
            </div>
        </div>
    );
};
export default withStyles(Constants.styles)(Research);